module.exports = __webpack_public_path__ + "img/76e33d95263b5ed7b1fb3051a275fdce.png";